import { Box, Icon, Text } from '@chakra-ui/react';
import MerchantLogo from './MerchantLogo';
import { IoLogOutOutline, IoPersonOutline } from 'react-icons/io5';
import CustomButton from './CustomButton';
import { useBreakpointsContext } from '../hooks/useBreakpointsContext';

type Props = { id?: string; logout: () => void };

const Header = ({ id, logout }: Props): JSX.Element => {
  const { isSmallScreen } = useBreakpointsContext();
  return (
    <Box
      display={'flex'}
      borderBottom={'1px solid'}
      borderColor={'#DFDEE2'}
      width={'100%'}
      justifyContent={'space-between'}
      px={['20px', '20px', '60px']}
      py={4}
    >
      <MerchantLogo boxHeight={['44px', '44px', '66px']} boxWidth={['110px', '110px', '160px']} />
      <Box display="flex" flexDirection={'row'} alignItems={'center'} gap={'24px'}>
        <Box
          display="flex"
          flexDirection={'row'}
          alignItems={'center'}
          px={isSmallScreen ? 2 : 6}
          py={2}
          gap={isSmallScreen ? 1 : 3}
        >
          <Icon as={IoPersonOutline} boxSize="20px" />
          <Text fontWeight={700}>{id}</Text>
        </Box>
        <CustomButton gap={'16px'} onClick={logout}>
          <Icon as={IoLogOutOutline} />
          {isSmallScreen ? '' : 'SALIR DEL PORTAL'}
        </CustomButton>
      </Box>
    </Box>
  );
};

export default Header;
